import { render, staticRenderFns } from "./touchpointList.vue?vue&type=template&id=f48c25aa"
import script from "./touchpointList.vue?vue&type=script&lang=js"
export * from "./touchpointList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports